import { apiFetch } from "@/lib/api-client";

export interface Company {
  id: number;
  name: string;
  is_active: number;
  created_at?: string;
  /** 启用状态的用户数（后端 company_list 子查询） */
  user_count?: number;
  /** 单独设置的计费单价 (分); null = 使用 .env 默认 */
  price_quote_fen?: number | null;
  price_image_fen?: number | null;
  /** 生效单价 (分) = 单独设置 ?? 默认 */
  effective_price_quote_fen?: number;
  effective_price_image_fen?: number;
  /** .env 默认单价 (分) */
  default_price_quote_fen?: number;
  default_price_image_fen?: number;
}

export interface CompanyListResponse {
  success: boolean;
  data: Company[];
  default_price_quote_fen?: number;
  default_price_image_fen?: number;
}

export interface CreateCompanyPayload {
  name: string;
  admin_username: string;
  admin_password: string;
  admin_display_name?: string;
}

export interface UpdateCompanyPayload {
  name?: string;
  is_active?: number;
  /** 整数分 (>=0); null = 恢复默认; 不传 = 不改 */
  price_quote_fen?: number | null;
  price_image_fen?: number | null;
}

export async function listCompanies(): Promise<CompanyListResponse> {
  return apiFetch("/api/admin/companies");
}

export async function createCompany(p: CreateCompanyPayload) {
  return apiFetch<{ success: boolean; company_id: number; admin_user_id: number }>("/api/admin/companies", {
    method: "POST",
    body: JSON.stringify(p),
  });
}

export async function updateCompany(id: number, p: UpdateCompanyPayload) {
  return apiFetch<{ success: boolean }>(`/api/admin/companies/${id}`, {
    method: "PATCH",
    body: JSON.stringify(p),
  });
}

export async function deleteCompany(id: number) {
  return apiFetch<{ success: boolean }>(`/api/admin/companies/${id}`, { method: "DELETE" });
}
